import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Main Footer */}
      <footer className="bg-[#2C2C90] text-white py-6">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Us Section */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-white">Contact Us</h2>
            {/* Social Media Icons */}
            {/* <div className="flex gap-4 mb-8">
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/instagram.svg" alt="Instagram" className="w-8 h-8" />
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/facebook.svg" alt="Facebook" className="w-8 h-8" />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/linkedin.svg" alt="LinkedIn" className="w-8 h-8" />
              </a>
            </div> */}

            {/* Call Us */}
            <div className="mb-8">
              {/* <h3 className="text-xl font-bold mb-4 text-white">Call Us</h3> */}
              <div className="space-y-0">
                <p>+91-8726620213</p>
              </div>
            </div>

            {/* Email Us */}
            <div className="mb-8">
              <h3 className="text-xl font-bold mb-4 text-white">Email Us</h3>
              <div className="space-y-2">
                <a href="mailto:hospitalbuild24@gmail.com" className="block">
                  hospitalbuild24@gmail.com
                </a>                
              </div>
            </div>

            {/* Our Address */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-white">Our Address</h3>
              {/* <p>303, A09 GDITL Tower,<br />Netaji Shubhas Place Pitampura,<br />New Delhi-110034</p> */}
              <p>New Delhi-110034</p>
            </div>
            {/* Social Media Icons */}
            <div className="flex gap-4 mb-8 mt-2">
              <a href="https://www.instagram.com/hospitalbuild25" target="_blank" rel="noopener noreferrer">
                <img src="/images/instagram.svg" alt="Instagram" className="w-8 h-8" />
              </a>
              <a href="https://www.facebook.com/share/1C8AsER3ec/" target="_blank" rel="noopener noreferrer">
                <img src="/images/facebook.svg" alt="Facebook" className="w-8 h-8" />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/linkedin.svg" alt="LinkedIn" className="w-8 h-8" />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-white">Quick Links</h2>
            <div className="space-y-3">
              <Link to="/" className="block transition-colors">
                Home
              </Link>
              <Link to="/products" className="block transition-colors">
                Products
              </Link>
              <Link to="/services/mgps" className="block transition-colors">
                Services
              </Link>
              <Link to="/about" className="block transition-colors">
                About Us
              </Link>
              <Link to="/blog" className="block transition-colors">
                Blog
              </Link>
              <Link to="/contact" className="block transition-colors">
                Contact Us
              </Link>
              <Link to="/career" className="block transition-colors">
                Career
              </Link>
              <p className='py-5'>We are a consulting company dedicated to transforming the future of health across the entire continum of care.</p>
            </div>
          </div>

          {/* Find Us Here Section */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-white">Find Us Here</h2>
            <iframe
              title="Map showing Hospital Build location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5724976677344!2d77.13373931508384!3d28.65397798241135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0357c6db2a3d%3A0x42c5b49a9f185e3a!2sM.R.Engg%20Works%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1645524557177!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>
      </footer>

      {/* Bottom Footer */}
      <div className="bg-[#1A1A5C] text-white py-2 border-t border-white/20">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <p>2024 Hospital Build. All rights reserved</p>
          <p>Designed and Developed by <span className="hover:text-[#00B300]">@atul</span></p>
        </div>
      </div>
    </>
  );
};

export default Footer; 